// eslint-disable-next-line @nx/enforce-module-boundaries
import { formatCompactNumber } from '@occc-app/lib/numbers';

export const formatMetricsValue = (value: number): string => {
  return formatCompactNumber(value);
};
